import React from 'react'

const Project_protein_performance = () => {
  return (
    <>
        <section
        data-aos="fade-up"
        style={{
          backgroundColor: '#eeeeee',
          color: '#333',
          padding: '100px 20px',
        }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-12 col-md-6 mb-4 mb-md-0"
              data-aos="fade-right"
            >
              <h3
                style={{
                  // fontSize: "52px",
                  fontWeight: 800,
                  marginTop: '20px',
                  color: '#000',
                  lineHeight: '62px',
                }}
              >
                PROJECT PROTEIN PERFORMANCE
              </h3>
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <ul
                      style={{
                        marginTop: '20px',
                        fontSize: '18px',
                        color: '#666',
                        lineHeight: '30px',
                      }}
                    >
                      <li>✔ Clean & Verified Protein</li>
                      <br />
                      <li>✔ Enhanced Absorption Formula</li>
                      <br />
                      <li>✔ Superior digestion & bioavailability</li>
                      <br />
                      <li>✔ Available in 2 delicious flavors</li>
                    </ul>
                  </div>
                  <div className="col-6">
                    <div
                      style={{
                        marginTop: '30px',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: '15px',
                      }}
                    >
                      <div style={{ color: '#444', fontSize: '16px' }}>
                        <p>
                          Energy: <b style={{ color: '#000' }}>126.1 kcal</b>
                        </p>
                        <p>
                          Protein: <b style={{ color: '#000' }}>23.1g</b>
                        </p>
                        <p>
                          Carbs: <b style={{ color: '#000' }}>4.8g</b>
                        </p>
                        <p>
                          Fat: <b style={{ color: '#000' }}>1.6g</b>
                        </p>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: '30px', display: 'flex', justifyContent:"center", gap: '15px' }}>
                <a href="/Shop">
                  <button className="pro-acc-logout-btn ">SHOP NOW</button>
                </a>
              </div>
            </div>

            <div
              className="col-12 col-md-6"
              data-aos="fade-left"
              style={{ textAlign: 'center'}}
            >
              <img
                src="/assets/images/new-images/Yeast Protein Pouch combo -1.png"
                alt="Fresh Image"
                className="resimg"
                style={{
                  width: '100%',
                  maxWidth: '300px',
                  border: '1px solid #EDE7E6',
                  borderRadius: '10px',
                  boxShadow: '1px 2px 10px #000',
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Project_protein_performance
